module.exports = __webpack_public_path__ + "static/media/visao.f7331e31.svg";